"use client";

export { WaitlistButton, WaitlistButtonLight } from "./WaitlistButton";
